import React, { Component } from 'react'
import { connect } from 'react-redux'
import data from './assets/data'
import { Link } from 'react-router-dom'
import AddToCalendar from 'react-add-to-calendar'
import 'react-add-to-calendar/dist/react-add-to-calendar.min.css'
import { importAll, isOdd } from '../utils/misc'
import Footer from './Footer'
import axios from 'axios';
import logoblockchain from './assets/img/logoblockchain.png'

// import multiple images
const speakersImg = importAll(require.context('./assets/img/speakers', false, /\.(png|jpe?g|svg)$/));
const nonprofitsImg = importAll(require.context('./assets/img/logos', false, /\.(png|jpe?g|svg)$/));
const partnersImg = importAll(require.context('./assets/img/partners', false, /\.(png|jpe?g|svg)$/));


@connect((store)=>{
  return {
    auth: store.user.auth
  } 
})
class Home extends Component {

  render() {

    // calendar icon
    let icon = { 'fas fa-calendar-plus calendaricon': 'left' };
    let offset = Intl.DateTimeFormat().resolvedOptions().timeZone

    let speakers = data.speakers.map((x,key) => {
      return (
        <div key={key} className={isOdd(key) ? 'tile flexChild' : 'tile flexChild flexSort'}>
          {/* <div className="calendarcontainer">
            <AddToCalendar
            buttonLabel={x.event.label}
            event={x.event}
            displayItemIcons={false}
            buttonTemplate={icon} />
          </div>
          <div className="calendartimezone">
          Timezone: {offset}
          </div> */}
          <img src={speakersImg[x.picture]} alt=""/>
          <div className="info">
          <div className="info-center">
          <div className="name">{x.name}</div>
          <div className="title">{x.title}</div>
          <div className="description">{x.description}</div></div>
        </div>
      </div>
      )
    })

    let nonprofits = data.nonprofits.map((x,key) => {
    return (
    <div key={key} className={isOdd(key)?'tile flexChild':'tile flexChild flexSort'}>
    <a href={x.url} rel="nofollow" target="_blank" className="img nonprofits">
    <img src={nonprofitsImg[x.logo]} alt={x.name}/></a></div>)
    })

    // let partners = data.partners.map((x,key) => {
    //   return (
    //   <div key={key} className={isOdd(key)?'tile flexChild':'tile flexChild'}>
    //   <a href={x.url} rel="nofollow" target="_blank" className="img nonprofits">
    //   <img src={nonprofitsImg[x.logo]} alt={x.name}/></a></div>)
    //   })
    
    let partners = data.partners.map((x,key) => {
        return (
        <div key={key} className="tileSmall flexChildSmall">
        <a href={x.url} rel="nofollow" target="_blank" className="img nonprofitsSmall">
        <img src={partnersImg[x.logo]} alt={x.name}/></a></div>)
        })      

    return (
  <div>
  <section id="section-home" className="section-1 color-1">
    <div className="section-content spacer">
    <img src={logoblockchain} width="240px" height="30px" />    
    <h1 className="section-title">The world's largest <br className="mobile-hide"/> Blockchain event</h1><br/>
    <h3 style={{fontWeight: '400',fontSize: '18px',color: 'rgba(255, 255, 255, 0.59)'}}  
    className="section-subtitle">Presented by <a href="https://hack-vc.com" target="_blank">Hack VC</a> - July 9-11, 2018 </h3>
  
    {/* <Link to="/register"><button className="btn-register btn btn-primary"> {this.props.auth ? 'View Dashboard' : 'Register now'} </button></Link><br/> */}
    <a href="https://www.youtube.com/playlist?list=PLfPAODZeDNiXDBFZjEjve8GrMKnLSaqeN" target="_blank"><button className="btn-register btn btn-primary">Watch recordings </button></a><br/>
    {/* <div style={{fontWeight: '400',fontSize: '14px',color: 'rgba(255, 255, 255, 0.19)',marginTop:'6px'}}><strong>64793</strong> registrations and counting...</div> */}
    <h3 id="attendees" className="section-subtitle">
    </h3>
  </div>
  <div className="btn-scroll"></div>
</section>
<section className="section-2 color-2">
  <div className="section-content">
    <h1 className="section-title">Learn from the experts <br/> of our craft</h1>
    <div className="tiles tiles-schedule">
    <div className="flex">
      {speakers}
      </div>
    </div>
  </div>
</section>
<section className="section-2 color-2 section-short">
  <div className="section-content">
    <h1 className="section-title">A pure virtual event, re-imagined for the modern era</h1>
    <h2 className="section-subtitle">Watch from the comfort of your home</h2>
    <h2 className="section-subtitle">Vote to democratize the best speaker questions</h2>
    <h2 className="section-subtitle">Chat in realtime with audience members</h2>
    <h2 className="section-subtitle">All sessions will be recorded and made available to you</h2>
  </div>
</section>
<section className="section-3 color-3 section-short">
  <div className="section-content">
    <h1 className="section-title">The largest developer event series in history</h1>
    <h1 style={{color: 'rgba(255, 255, 255, 0.59)'}} 
    className="section-subtitle"><a href="https://2014.hacksummit.org/" target="_blank">2014</a>: 64,000+ attendees</h1>
    <h1 style={{color: 'rgba(255, 255, 255, 0.59)'}} 
    className="section-subtitle"><a href="https://2016.hacksummit.org/" target="_blank">2016</a>: 80,000+ attendees</h1>
  </div>
</section>
<section className="section-4 color-4">
  <div className="section-content">
    <h1 className="section-title">Support great causes</h1>
    <h2 className="section-subtitle"><strong>All ticket</strong> proceeds go towards an alliance of technology non-profits.</h2>
    <div className="tiles tiles-logos">
      <div className="flex">
        {nonprofits}
      </div><br/><br/>
    </div>
  </div>
</section>
<section className="section-3 color-3">
  <div className="section-content">
    <h1 className="section-title">Partners</h1>
    <div className="flexSmall">
        {partners}
      </div><br/><br/>
    </div>
</section>
<section className="color-2 section-short">
  <div className="section-content">
    <h1 className="section-title">Our Goals</h1>
    <h2 className="section-subtitle">To provide free technical education on blockchain to the world</h2>
    <h2 className="section-subtitle">To raise money for coding non-profits</h2>
    <h2 className="section-subtitle">To encourage mentorship among software developers</h2>
  </div>
</section>
<section className="color-1 section-short">
  <div className="section-content">
    <h1 className="section-title">Virtual Hackathon</h1>
    <h2 className="section-subtitle">Win tokens, make friends, and have fun. </h2>
    <h2 className="section-subtitle">Hack for a cause to help coding non-profits.</h2>
    <h2 className="section-subtitle"><a href="/hackathon">Learn More</a></h2>
  </div>
</section>
{/* <section className="color-2 section-short">
  <div className="section-content">
    <h1 className="section-title">Our Partners</h1>
    <h2 className="section-subtitle">Committed to helping coding non-profits. </h2>
    <h2 className="section-subtitle">Want to be part of this?&nbsp;<a href="mailto:contact@hacksummit.org" target="_blank">Contact us</a></h2>
    <div className="tiles tiles-partners">
      <div className="flex">
      {nonprofits}
      </div>
    </div>
  </div>
</section> */}
<section className="color-3">
  <div className="section-content">
    <h1 className="section-title">Donation optional</h1>
    <h2 className="section-subtitle">Not in a position to donate?</h2>
    <h2 className="section-subtitle">Attend for free by sharing on social media, to help find more donors</h2>
  </div>
  <Footer/>
</section>
      </div>)
    }

}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js